// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"6de2f713","453":"3ee75bdf","567":"f5542aec","777":"50665903"}[chunkId] + ".chunk.js";
};